export interface Review {
  name: string
  category: string
  quote: string
  sourceUrl: string
}

export const reviews: Review[] = [
  {
    "name": "Sarah Donovan",
    "category": "Auto glass",
    "quote": "Repaired my windshield chip for much less than competitors. Little to no hassle and they got me in as soon as I called.",
    "sourceUrl": "https://maps.app.goo.gl/Hoy2fC5UHc62onMJ7"
  },
  {
    "name": "Robert Hutchison",
    "category": "Commercial glass",
    "quote": "I thought I needed a large plate glass window replaced in my commercial building. … They were honest, I thought we needed two windows.",
    "sourceUrl": "https://maps.app.goo.gl/jeErexVhELTmmZhZA"
  },
  {
    "name": "Devon Ross",
    "category": "Residential glass",
    "quote": "Kosin's just completed a whole house glass replacement for us in one day to fix our 35 windows with broken seals.",
    "sourceUrl": "https://maps.app.goo.gl/fJFjgXszrpdHEgU2A"
  },
  {
    "name": "Jennifer Bainbridge",
    "category": "Glass shower doors",
    "quote": "Precise and detailed. Fair pricing. I highly recommend Kosin's for any mirror or custom shower doors! Extremely satisfied customer!",
    "sourceUrl": "https://maps.app.goo.gl/o1b3FPhZHh3qCwP69"
  }
]

